import { isOrderPedidoLiberado, isOrderRetornoByRequestStatus } from '../utils/retornoStatus';

export function computeRetornoFilterCounts(orders, config = {}) {
  const {
    codstatusRetorno = '',
    extraRetornoStatuses = [],
    codstatusPedidoVinculado = '',
  } = config;

  if (codstatusRetorno === '' && extraRetornoStatuses.length === 0) {
    return { aguardando: 0, liberado: 0, ocultar: 0 };
  }

  let aguardando = 0;
  let liberado = 0;
  let ocultar = 0;

  (orders || []).forEach((ordem) => {
    const isRetorno = isOrderRetornoByRequestStatus(
      ordem,
      codstatusRetorno,
      extraRetornoStatuses
    );
    if (!isRetorno) {
      ocultar += 1;
      return;
    }
    if (isOrderPedidoLiberado(ordem, codstatusPedidoVinculado)) {
      liberado += 1;
    } else {
      aguardando += 1;
    }
  });

  return { aguardando, liberado, ocultar };
}
